import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const GroupsBackendApi = createApi({
	reducerPath: "GroupsBackend",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getDevicesByGroup: builder.query({
			query: (val) => `vehicles/groups?groupId=${val}`,
		}),
		getSubGroupsByGroup: builder.query({
			query: (val) => `groups?groupId=${val}`,
		}),
		getAllGroups: builder.query({
			query: (val) => `groups?userId=${val}`,
		}),
	}),
});

export const {
	useLazyGetDevicesByGroupQuery,
	useLazyGetSubGroupsByGroupQuery,
	useGetAllGroupsQuery,
	useGetDevicesByGroupQuery,
} = GroupsBackendApi;
